import { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import FormField from "../components/FormField";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { cerberus } from "../api/cerberus";
import { useSubmit } from "../lib/useSubmit";

export default function PasswordResetRequest(): JSX.Element {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const { busy, error, onSubmit } = useSubmit(async () => {
    await cerberus.passwordResetRequest({ email });
    setDone(true);
  }, "request failed");

  if (done) {
    return (
      <AuthLayout title="Verifique seu email">
        <Alert variant="success">
          Se {email} estiver cadastrado, enviamos um link para redefinir a senha.
        </Alert>
        <Link to="/login">Voltar ao login</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Redefinir senha"
      subtitle="Vamos mandar um link para seu email."
      footer={<Link to="/login">Voltar ao login</Link>}
    >
      {error ? <Alert variant="error">{error}</Alert> : null}
      <form onSubmit={onSubmit} noValidate>
        <FormField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? "Enviando..." : "Enviar link"}
        </Button>
      </form>
    </AuthLayout>
  );
}
